import { render } from "./Timestamp.vue?vue&type=template&id=6621488a"
import script from "./Timestamp.vue?vue&type=script&lang=js"
export * from "./Timestamp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/edvardaskostkevicius/WebstormProjects/rv_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__